module.exports = __webpack_public_path__ + "img/map.c5ac4d7f.png";